import { useCallback } from 'react';
import { riderWork as wiredRiderWork } from '../../api/riderWork';
import ApiPhoto from '../ApiPhoto';
import './packageSeen.css';

/**
 * The client's own photo of the parcel, shown to the rider once the job is
 * theirs (Rio, 11 Oct 2026: "we need to confirm the pickup of something we
 * have not seen"), so they can check the one they collect is this one.
 */
export default function ClientParcelPhoto({ deliveryId, riderWork = wiredRiderWork }) {
  const load = useCallback(() => riderWork.packagePhoto(deliveryId), [riderWork, deliveryId]);

  return (
    <section className="ps-card" aria-label="The client's photo of the parcel">
      <h2 className="ps-h">The client's photo of the parcel</h2>
      <p className="ps-hint">Check the parcel you collect is this one.</p>
      <ApiPhoto load={load} alt="The parcel, as the client photographed it" className="ps-img" />
    </section>
  );
}
